import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FeatureFlagsState } from './featureFlagsReducer.types';

const initialState: FeatureFlagsState = {
  flags: {},
  lastFetched: null,
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<FeatureFlag[]>) => {
      const flags = action.payload;
      if (!Array.isArray(flags)) {
        return;
      }

      const flagsRecord: Record<string, FeatureFlag> = {};
      flags.forEach((flag) => {
        flagsRecord[flag.key] = flag;
      });

      const hasChanges =
        JSON.stringify(state.flags) !== JSON.stringify(flagsRecord);
      if (hasChanges) {
        state.flags = flagsRecord;
      }
      state.lastFetched = Date.now();
    },
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
